import React from 'react'

import ArrowTopRightSquare from '../../../assets/icons/arrow-top-right-on-square.svg?react'

type Props = { url: string, children: React.ReactNode | string }

const ExternalLink: React.FC<Props> = ({ url, children }) => {
  return (
    <a href={url} className='inline-flex items-center gap-x-2'>
      <ArrowTopRightSquare height={20} width={20} /> {children}
    </a>
  )
}

export default ExternalLink
